// Add your JS customizations here
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Draggable from "gsap/Draggable";
import counterUp from 'counterup2'
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Draggable);

(function($) {

	if ( $("#vertical-slides").length ) {

    let panels = gsap.utils.toArray(".vertical-slide");
		let ih = window.innerHeight;
		let end = ih*panels.length*0.25;

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#vertical-slides",
        start: "center center",
        end: () => `+=${end}`,
        //anticipatePin: 1,
        pin: true,
        scrub: true,
        //markers: true,
        //snap: 1 / (panels.length - 1),
        snap: {
          snapTo: 1 / (panels.length - 1), // snap to the closest label in the timeline
          duration: {min: 0.2, max: 0.5}, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
          delay: 0, // wait 0.2 seconds from the last scroll event before doing the snapping
          //ease: "power1.inOut" // the ease of the snap animation ("power3" by default)
        }
      }
    });
    
    panels.forEach((panel, i) => {
      if(i === 0) return;
      tl.fromTo(panels[i-1], {
        yPercent: 0,
        autoAlpha: 1,
        ease: "power2.out"
      }, {
        yPercent: -20,
        autoAlpha: 0
      }).fromTo(panel, {
        yPercent: 20,
        autoAlpha: 0,
        ease: "power2.out"
      }, {
        yPercent: 0,
        autoAlpha: 1
      })
      tl
    });

/*     gsap.utils.toArray(".vertical-slide").forEach((panel, i) => {
      ScrollTrigger.create({
        trigger: panel,
        start: "center center",
        end: "bottom center",
        pin: true, 
        scrub: 1,
        pinSpacing: false,
        markers: true,
        onEnter: () => {
          gsap.to(panel, {duration: 0.3, autoAlpha: 1});
        },
        onEnterBack: function() {
          gsap.to(panel, {duration: 0.3, autoAlpha: 1});
        },
        onLeave: () => {
          gsap.to(panel, {duration: 0.3, autoAlpha: 0});
        },
        onLeaveBack: function() {
          gsap.to(panel, {duration: 0.3, autoAlpha: 0});
        }
      });
    }); */
		
		/* const slidesScroller = document.querySelector("#vertical-slides");
		const slides = document.querySelectorAll(".vertical-slide");
		const container = document.querySelector("#vertical-slides-wrap");
		let oldSlide = 0;
		let activeSlide = 0;
		let dur = 0.5;
		let offsets = [];
		let ih = window.innerHeight;
		let end = ih*(slides.length-1)*0.5;
		$(".carousel-indicator").on('click', setAnim);

		const timeline = gsap.timeline({
			paused: false,
			defaults: {
				overwrite: "auto"
			},
			scrollTrigger: {
				end: () => `+=${end}`,
				//anticipatePin: 1,
				pin: true,
				//pinSpacing: true,
				scrub: 1,
				start: "center center",
				//snap: 1,
				onUpdate: self => {
					slideAnim(self.progress.toFixed(3));
				},
				markers: true,
				trigger: slidesScroller
			}
		});

		function setAnim(event) {
			let target = activeSlide;
			if ( typeof event !== 'undefined' ) {
				target = $(event.delegateTarget).parents('.vertical-slide').index()+1;
			}
			let scrollprogress = $('#vertical-slides').parents('.pin-spacer').offset().top + end * target / slides.length;
			gsap.to(window, {duration: 0.3, scrollTo: scrollprogress});
		}

		// create nev dots and add tooltip listeners
		for (let i = 0; i < slides.length; i++) {
			offsets.push(-slides[i].offsetTop);
		}

		// figure out which of the 4 nav controls called the function
		function slideAnim(progress) {

			oldSlide = activeSlide;
			// dragging the panels
			if (gsap.isTweening(container)) {
				return;
			}

			activeSlide = Math.floor(slides.length * progress);

			// make sure we're not past the end or beginning slide
			activeSlide = activeSlide > slides.length - 1 ? slides.length - 1 : activeSlide;
			if (oldSlide === activeSlide) {
				return;
			}
			// if we're dragging we don't animate the container
			gsap.to(container, dur, { y: offsets[activeSlide], ease: "power2.inOut" });
		}

		window.addEventListener("resize", newSize);

		newSize();
		function newSize() {
			offsets = [];
			ih = window.innerHeight;
			end = ih*(slides.length-1)*0.8;
			for (let i = 0; i < slides.length; i++) {
				offsets.push(-slides[i].offsetTop);
			}
			gsap.set(container, { y: offsets[activeSlide] });
			//setAnim();
			//timeline.restart();
		} */

	}

  var lastScrollTop = 0;
	function menuScroll() {
		var st = window.pageYOffset || document.documentElement.scrollTop;
		if (st > lastScrollTop){
			// downscroll code
			//console.log('downscroll');
      if ( $(window).scrollTop() > $('#main-nav').outerHeight() ) {
        $('nav.navbar').addClass('navbar--up');
      }
		} else {
			// upscroll code
			//console.log('upscroll');
      $('nav.navbar').removeClass('navbar--up');
		}
		lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	}
	$(window).scroll(function(event){
		menuScroll();
	});

  $(document).on('ready', function(){
    $('.dropdown-toggle').each(function(){
      var offset_left = $(this).offset().left - $('#main-nav').children('.container').offset().left - 15;
      $(this).next().find('.nav-dropdown-menu').offset({left: offset_left});
    });
  });

  $(window).on('resize', function(){
    $('.dropdown-toggle').each(function(){
      var offset_left = $(this).offset().left - $('#main-nav').children('.container').offset().left - 15;
      $(this).next().find('.nav-dropdown-menu').css({left: offset_left});
    });
  });

  var carousel = $('.alerts-container');
  carousel.slick({
    arrows: false,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('input[name=btnCategory').on('click', e => {
    var target = '.'+e.target.value;
    carousel.slick('slickUnfilter');
    if (e.target.value === 'All') {
      carousel.slick('slickGoTo', 0, true);
      return;
    } else {
      carousel.slick('slickFilter', target);
    }
  });

})( jQuery );

//Logic for intersection observer to init countup on scroll 
const callback = entries => {
  entries.forEach(entry => {
      const el = entry.target
      if (entry.isIntersecting) {
          counterUp(el, {
              duration: 2000, //Duration of animation
              delay: 100, //Animation delay 
          })
      }
  })
}
//Init intersection observer for countup el
const IO = new IntersectionObserver(callback, { threshold: 1 })
const el = document.querySelectorAll('.counter');
el.forEach(el => {
    IO.observe(el);
})